// charactors
export const reg = new RegExp(
  /^\S*(?=\S{8,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[`~|\\:;"'<,>.\/}{[\]!@#$%=^&*?()_+-])\S*$/,
);

// Chinese
export const chineseReg = new RegExp('[\u4e00-\u9fa5]');
